/*
 * @Descripttion: 整理逻辑,添加备注!!!
 * @version:
 * @Author: Wang
 * @Date: 2021-03-18 16:43:02
 * @LastEditors: ------
 * @LastEditTime: 2021-09-13 13:46:23
 */
import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import NotFoundComponent from "../views/404.vue";

Vue.use(Router);

const routes = [
  { path: "*", component: NotFoundComponent },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "爱介护官网-首页"
    }
  },
  {
    path: "/serve",
    component: () => import("../views/Serve.vue"),
    name: "serve",
    meta: {
      title: "爱介护-服务项目"
    }
  },
  {
    path: "/site",
    component: () => import("../views/Site.vue"),
    name: "site",
    meta: {
      title: "爱介护-服务站点"
    }
  },
  {
    path: "/about",
    component: () => import("../views/About.vue"),
    name: "about",
    meta: {
      title: "爱介护-关于我们"
    }
  },
  {
    path: "/newscenter",
    component: () => import("../views/Newscenter.vue"),
    name: "newscenter",
    meta: {
      title: "爱介护-新闻中心"
    }
  },
  {
    path: "/newsdetail",
    component: () => import("../views/Newsdetail.vue"),
    name: "newsdetail",
    meta: {
      title: "爱介护-新闻详情"
    }
  },
  {
    path: "/join",
    component: () => import("../views/Join.vue"),
    name: "join",
    meta: {
      title: "爱介护-加入我们"
    }
  },
  {
    path: "/bannerlive",
    component: () => import("../views/Bannerlive.vue"),
    name: "bannerlive",
    meta: {
      title: "爱介护-养老服务平台"
    }
  }
];
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // 切换路由后滚动条置顶
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  }
});
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js